/**
 * Formateo de tamaños de archivo — UNA sola casa. Antes había cinco variantes
 * repartidas (fmtSize, fmtTam, inline en el modal del ZIP, y `.toFixed()`
 * sueltos en Ventas, correos y editores) que redondeaban distinto entre sí.
 */

/** Tamaño legible: «12 KB» · «1.2 MB» · «1.2 GB». Nunca «0 KB» para algo con bytes. */
export function fmtBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return "—";
  const KB = 1024;
  const MB = KB * 1024;
  const GB = MB * 1024;
  if (bytes >= GB) return `${(bytes / GB).toFixed(1)} GB`;
  if (bytes >= MB) return `${(bytes / MB).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / KB))} KB`;
}

/**
 * Solo el número en MB con dos decimales (sin unidad). Existe para los textos
 * de límites de adjuntos («10.00 MB por archivo, 15.00 MB en total») donde la
 * unidad la pone la frase; para mostrar el tamaño de un archivo usa `fmtBytes`.
 */
export function fmtMB(bytes: number): string {
  return (bytes / 1024 / 1024).toFixed(2);
}

/**
 * El Message-ID de un correo, sin los picoparéntesis del formato de transporte.
 *
 * Desde la migración 0078 el backend los guarda SIEMPRE con `<>` (es lo que
 * entregan `make_msgid()` al enviar y el ENVELOPE de IMAP al leer, así que
 * normalizar hacia ese formato quita transformaciones en las dos puntas). Los
 * ángulos son parte del sobre, no algo que un humano necesite ver.
 */
export function mostrarMsgId(valor: string | null | undefined): string {
  if (!valor) return "";
  return valor.trim().replace(/^<+/, "").replace(/>+$/, "").trim();
}

/**
 * El folio sin su cola: `CASO-2026-00080-072126-1219` → `CASO-2026-00080`.
 *
 * El folio completo trae fecha y hora de creación al final. Eso sirve para
 * distinguir y para pegar en el portal del proveedor, pero dentro de un botón
 * («Agregar al CASO-2026-00080-072126-1219») no cabe en móvil y no aporta: el
 * tercer bloque ya es el consecutivo y es único.
 *
 * Siempre acompáñalo del folio completo en un `title`, para quien lo necesite.
 */
export function folioCorto(folio: string | null | undefined): string {
  if (!folio) return "";
  const partes = folio.split("-");
  return partes.length > 3 ? partes.slice(0, 3).join("-") : folio;
}
